export const BASE_URL = "https://fyk1mokuc6.execute-api.us-east-2.amazonaws.com/dev"